import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div
            data-testid="not-found-page"
            className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6 lg:px-8"
        >
            <div className="text-xs font-semibold uppercase tracking-widest text-[color:var(--brand-green)]">
                404
            </div>
            <h1 className="mt-2 font-display text-4xl font-extrabold text-[color:var(--brand-navy)]">
                Page not found
            </h1>
            <p className="mt-4 text-slate-600">
                The page you&apos;re looking for went for a ride.
            </p>
            <Link
                to="/"
                data-testid="notfound-home-link"
                className="hero-cta pill-btn mt-8 inline-flex text-white"
            >
                Return home
            </Link>
        </div>
    );
}
